export const hasOpened = (grand_opening) =>
  !grand_opening || new Date() > new Date(grand_opening);

export const formatName = (location, willOpen) =>
  typeof location === 'string'
    ? location.replace(`(${willOpen})`, '')
    : location;
